import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api, toastErr } from "@/lib/api";
import { Card } from "./ui";

export const AnalyticsTab = () => {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then((r) => setA(r.data)).catch(toastErr); }, []);
  if (!a) return <Loader2 className="animate-spin text-slate-400" />;

  const stats = [["Sessions", a.sessions], ["User messages", a.messages], ["Avg response", `${a.avg_latency_ms} ms`], ["Tokens used", a.tokens.toLocaleString()], ["Knowledge docs", `${a.knowledge_docs} · ${(a.chunks || 0).toLocaleString()} chunks`]];
  const max = Math.max(1, ...a.per_day.map((d) => d.count));
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {stats.map(([label, value]) => (
          <div key={label} data-testid="analytics-stat-card" className="bg-white rounded-2xl border border-slate-200/80 p-5 shadow-sm">
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{label}</p>
            <p className="mt-2 text-2xl font-semibold text-slate-900">{value}</p>
          </div>
        ))}
      </div>
      <div className="grid lg:grid-cols-[1fr_320px] gap-6">
        <Card title="Messages per day (last 30 days)">
          {a.per_day.length === 0 ? <p className="text-sm text-slate-500">No activity yet.</p> : (
            <div className="flex items-end gap-1 h-40">
              {a.per_day.map((d) => (
                <div key={d.day} className="flex-1 flex flex-col items-center gap-1 group" title={`${d.day}: ${d.count}`}>
                  <span className="text-[10px] text-slate-500 opacity-0 group-hover:opacity-100">{d.count}</span>
                  <div className="w-full bg-indigo-500 rounded-t-md min-h-[3px]" style={{ height: `${(d.count / max) * 120}px` }} />
                  <span className="text-[10px] text-slate-400">{d.day.slice(5)}</span>
                </div>
              ))}
            </div>
          )}
        </Card>
        <Card title="Models used">
          {a.models.length === 0 ? <p className="text-sm text-slate-500">—</p> : (
            <ul className="space-y-2">
              {a.models.map((m) => (
                <li key={m.model} className="flex justify-between text-sm"><span className="truncate text-slate-700">{m.model}</span><span className="font-mono text-slate-500">{m.count}</span></li>
              ))}
            </ul>
          )}
        </Card>
      </div>
    </div>
  );
};
